/* jshint esnext: true */

const gameData = {

	money: 0,

	currentItem: 1,

	items: [ 1 ],

	currentBackgroundColor: 0x000,

	currentLevel: 0,


	/**
	 * Spend money.
	 */
	spend: function( amount = 0 ) {

		if ( amount <= 0 ) {
			return false;
		}

		if ( this.money - amount < 0 ) {
			return false;
		}

		this.money = this.money - amount;

		$( '.value.money' ).html( gameData.money );

		store.update();

		return true;

	},


	/**
	 * Earn money.
	 */
	earn: function( amount = 0 ) {

		if ( amount <= 0 ) {
			return;
		}

		this.money = this.money + amount;

		$( '.value.money' ).html( gameData.money );

		store.update();

	},

	setLevel: function( level ) {

		gameData.currentLevel = level;

		$( '.value.level' ).html( gameData.currentLevel );

	},


	setSpeed: function( speed ) {

		let new_speed = ( 1000 / speed ) * settings.tileWidth;
		new_speed = new_speed.toFixed( 1 );

		new_speed = new_speed.replace( '.0', '' );

		$( '.value.speed' ).html( new_speed + 'px/s' );

	},

	// saveGameplay: function( data ) {


	// }

};
